import React, { useState } from "react";
import axios from "axios";
import Style from "../Style/TestimonialForm.module.scss";

const TestimonialForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    feedback: "",
    designation: "",
  });

  const [message, setMessage] = useState("");
  const baseURL = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${baseURL}/api/testimonials`, formData);
      setMessage("✅ Testimonial added successfully!");
      setFormData({ name: "", location: "", feedback: "" });
    } catch (err) {
      setMessage("❌ Error adding testimonial");
      console.error(err);
    }
  };

  return (
    <div className={Style.TestimonialForm}>
      <div className={Style.wrapper}>
        <div className={Style.TestimonialFormAdd}>
          <h2>Add Testimonial</h2>
        </div>
        <div className={Style.TestimonialFormDisk}>
          <form onSubmit={handleSubmit} className={Style.testimonialForm1}>
            <div className={Style.TestimonialFormIn}>
              <input
                type="text"
                name="name"
                placeholder=" Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className={Style.TestimonialFormIn}>
              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />
            </div>
            <div className={Style.TestimonialFormIn}>
              <input
                type="text"
                name="Designation"
                placeholder="designation"
                value={formData.designation}
                onChange={handleChange}
                required
              />
            </div>
            <div className={Style.TestimonialFormIn}>
              <textarea
                name="feedback"
                placeholder="Feedback"
                value={formData.feedback}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit">Submit</button>
          </form>
          {message && <p className={Style.message}>{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default TestimonialForm;
